import React ,{useState,useEffect, useRef}from "react";
import styled from "styled-components";
import ChatInput from "./ChatInput";
import axios from "axios";
import { getAllMessagesRoute, sendMessageRoute } from "../utils/APIRoutes";
import { v4 as uuidv4 } from "uuid";



export default function ChatContainer({ currentChat, socket }){

    const [messages,setMessages] = useState([]);
    const [arrivalMessage,setArrivalMessage] = useState(null)
    const scrollRef = useRef();
    const [Time, setTime] = useState(new Date());
    var t = "";
    var d="";

    
    useEffect(() => {
      if(currentChat){
      const fetchi = async () => {
        const data = await JSON.parse(
          localStorage.getItem(process.env.REACT_APP_LOCALHOST_KEY)
        );

      const response = await axios.post(getAllMessagesRoute,{
        from: data._id,
        to: currentChat._id,
          
      });
      setMessages(response.data);
      // alert(currentChat._id);
    
  }
      
      fetchi();
    }
  },[currentChat]);

  useEffect(() => {
    const getCurrentChat = async () => {
      if (currentChat) {
        await JSON.parse(
          localStorage.getItem(process.env.REACT_APP_LOCALHOST_KEY)
        )._id;
      }
    };
    getCurrentChat();
  }, [currentChat]);

    const handleSendMsg = async (msg) => {
      // console.log(Time.toLocaleTimeString());
      const data = await JSON.parse(
      localStorage.getItem(process.env.REACT_APP_LOCALHOST_KEY)
    );

      setTime(new Date());
      t = Time.toLocaleTimeString();
      d = Time.toLocaleDateString();
      socket.current.emit("send-msg", {
        to:currentChat._id,
        from:data._id,
        message:msg,
        time:t,
        date:d,
      });
     
      
        await axios.post(sendMessageRoute,{
            from: data._id,
            to: currentChat._id,
            message: msg,
            time:t,
            date:d,
            
        });
        
        
        const msgs=[...messages];
        msgs.push({ fromSelf:true,message:msg,time:t,date:d});
        setMessages(msgs);
        
        
    };
    useEffect(() =>{
      
      if(socket.current){
        
        socket.current.on("msg-receive",(msg,time,date)=>{
        
        setArrivalMessage({fromSelf: false,message:msg,time:time,date:date});
        });
      }
    },[currentChat]);

    
    useEffect(() =>{
      arrivalMessage && setMessages((prev) => [...prev, arrivalMessage]);
    },[arrivalMessage]);

    useEffect(() => {
      scrollRef.current?.scrollIntoView({ behaviour: "smooth"});
    },[messages]);
    
    return(
        <>
        {currentChat &&(
           <Container>
            <div className="chat-header">
                <div className="user-details">
                    <div className="username">
                        <h3>{currentChat.username}</h3>
                    </div>
                </div>
                
            </div>

            <div className="chat-messages">
        {messages.map((message) => {
          return (
            <div ref= {scrollRef} key={uuidv4()}>
              
              <div
                className={`message ${message.fromSelf ? "sended" : "recieved"}`}>
                <div className="content ">
                  <p>{message.message}</p>
                  <div className="td">
                  <p>{message.time} {message.date}</p>
                  </div>

                </div>
              </div>
            </div>
          );
        })}

                
            </div>
            <ChatInput handleSendMsg = {handleSendMsg} />
           </Container>
     )}

           </>);
}

const Container = styled.div`
display: grid;
  grid-template-rows: 10% 80% 10%;
  // gap: 0.1rem;
  overflow: hidden;
  @media screen and (min-width: 720px) and (max-width: 1080px) {
    grid-template-rows: 15% 70% 15%;
  }
  .chat-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 2rem;
    border: 0.1rem solid #bf9b30;
    border-radius: 0.4rem;
    .user-details {
      display: flex;
      align-items: center;
      gap: 1rem;
      .username {
        h3 {
          color: white;
        }
      }
    }
  }
  .chat-messages {
    padding: 1rem 2rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 0.2rem;
      &-thumb {
        background-color: #bf9b30;
        width: 0.1rem;
        border-radius: 1rem;
      }
    }
    .message {
      display: flex;
      align-items: center;
      .content {
        max-width: 40%;
        overflow-wrap: break-word;
        padding: 1rem;
        font-size: 1.1rem;
        border-radius: 1rem;
        color: #00000;
        @media screen and (min-width: 720px) and (max-width: 1080px) {
          max-width: 70%;
        }
        .td{
          color: #d1d155;
          font-size:0.8rem;
          display:flex;
          justify-content: flex-end;
        }
      }
    }
    .sended {
      justify-content: flex-end;
      .content {
        background-color: #ffffff;
      }
    }
    .recieved {
      justify-content: flex-start;
      .content {
        background-color: #f3f6f4;
        .td{
          justify-content: flex-start;
        }
      }
      
    }
  }
`;